import { render, staticRenderFns } from "./address-remark-modify.vue?vue&type=template&id=7548267b"
import script from "./address-remark-modify.vue?vue&type=script&lang=ts"
export * from "./address-remark-modify.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports